import React from 'react';

const LoadingScreen = ({ message = 'Loading CompanionCab' }) => {
  return (
    <div className="modern-loading-screen">
      <div className="loading-container">
        <div className="heart-spinner">
          <div className="heart-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="currentColor"/>
            </svg>
          </div>
          <div className="heart-pulse-ring"></div>
          <div className="heart-pulse-ring heart-pulse-ring-2"></div>
        </div>
        <div className="loading-brand">
          <h1>Companion Cab</h1>
          <p>Your trusted transportation companion</p>
        </div>
        <div className="loading-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
